var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('value'),"name":"value","type":"text","rules":_vm.valueRules},model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }